import React from 'react'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { format } from 'date-fns'
import { getLocale } from 'app/translations/intl-context'
import { getDateFnsLocale } from 'commons/date'

/*
  MuiPickersUtilsProvider uses date-fns for date formatting.
  This provider customizes the date display for the Thai locale ('th') 
  by overriding the default DateFnsUtils formatting functions
  to show the Buddhist calendar year (by adding 543).
 */

class ThaiDateFnsUtils extends DateFnsUtils {
  // manually replace with buddhist year in the date display
  format(date, formatString) {
    const gregorianYear = date.getFullYear()
    const buddhistYear = gregorianYear + 543
    const formattedDate = format(date, formatString, { locale: this.locale })

    return formattedDate.replace(
      gregorianYear.toString(),
      buddhistYear.toString(),
    )
  }

  // buddhist year selection in the year view
  getYearText(date) {
    return (date.getFullYear() + 543).toString()
  }

  // month name with buddhist year in the month view
  getCalendarHeaderText(date) {
    return this.format(date, 'MMMM')
  }
}

function getDateFnsUtils() {
  const locale = getLocale()
  if (locale === 'th') {
    return ThaiDateFnsUtils
  } else {
    return DateFnsUtils
  }
}

const LocalizedDatePickerProvider = ({ children }) => {
  return (
    <MuiPickersUtilsProvider
      utils={getDateFnsUtils()}
      locale={getDateFnsLocale()}
    >
      {children}
    </MuiPickersUtilsProvider>
  )
}

export default LocalizedDatePickerProvider
